import React, { useState } from 'react';
import { Space } from 'antd';
import CameraCaptureField from './CameraCaptureField';
import PhotoStrip from './PhotoStrip';

export interface LineItemPhotosControlProps {
  lineItemId: number;
  phase: 'finding' | 'completed';
}

const LineItemPhotosControl: React.FC<LineItemPhotosControlProps> = ({ lineItemId, phase }) => {
  // Bump on upload so the strip re-fetches and shows the new photo immediately.
  const [reloadKey, setReloadKey] = useState(0);
  return (
    <Space direction="vertical" size="small">
      <PhotoStrip entityType="line_item" entityId={lineItemId} subType={phase} editable reloadKey={reloadKey} />
      <CameraCaptureField
        purpose={phase}
        entityType="line_item"
        entityId={lineItemId}
        onUploaded={() => setReloadKey((k) => k + 1)}
      />
    </Space>
  );
};

export default LineItemPhotosControl;
